import { render, staticRenderFns } from "./RequirementPage.vue?vue&type=template&id=c26bfb9a&scoped=true&"
import script from "./RequirementPage.vue?vue&type=script&lang=js&"
export * from "./RequirementPage.vue?vue&type=script&lang=js&"
import style0 from "./RequirementPage.vue?vue&type=style&index=0&id=c26bfb9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26bfb9a",
  null
  
)

export default component.exports